module.exports = __webpack_public_path__ + "img/13.f2f98f7d.jpg";